import React from "react";

import UpcForm from "./components/upc-form";
import UpcTable from "./components/upc-table";

import "./upcs.scss";

const ShipmentUpcs = (props) => {
    return (
        <fieldset>
            <legend>UPCs For This Shipment</legend>
            <div className="row">
                <div className="column -span4">
                    <UpcForm />
                </div>
                <div className="column -span8">
                    <UpcTable shipmentKey={props.shipmentKey} />
                </div>
            </div>
        </fieldset>
    );
};

export default ShipmentUpcs;
